import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material';

@Component({
  selector: 'app-mycustomers-view-dialog',
  templateUrl: './mycustomers-view-dialog.component.html',
  styleUrls: ['./mycustomers-view-dialog.component.css']
})
export class MycustomersViewDialogComponent implements OnInit {
  viewdata: any;
  constructor(
    private dialogRef: MatDialogRef<MycustomersViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.viewdata = this._data;
    console.log(this.viewdata)
  }

  close() {
    this.dialogRef.close();
  }

}
